import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style.css'
import './assets/lite-purple.min.css'
import './assets/iconsmind/iconsmind.css'
import {i18n} from './plugin/i18n'
import JQuery from 'jquery'
import VueApexCharts from 'vue-apexcharts'
import { Notification } from 'element-ui';



//console.log(JSON.parse(localStorage.getItem('_tuccar')).Token.access_token);

window.axios = require('axios');

window.axios.defaults.headers.common['Authorization'] = localStorage.getItem('_tuccar')? 'Bearer ' + JSON.parse(localStorage.getItem('_tuccar')).Token.access_token:null;
window.axios.defaults.headers.common['Content-Type'] = 'application/json';
//console.log(window.axios.defaults.headers)

global.jQuery = JQuery;
global.$ = JQuery;

Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts)

//Vue.use(Notification);

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  Notification,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js